import {Component, Input, OnInit} from '@angular/core';
import {PatientDataModel} from '../../../../models/patient/patient-data.model';
import {Globals} from '../../../../globals';
import {PatientService} from '../../../patient/patient.service';
import {TreatmentPlanningService} from '../../../treatment-planning/treatment-planning.service';
import {FileManagerService} from '../../../file-manager/file-manager.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {LoginService} from '../../../auth/login/login.service';

@Component({
  selector: 'app-collage-publish',
  templateUrl: './collage-publish.component.html',
  styleUrls: ['./collage-publish.component.css']
})
export class CollagePublishComponent implements OnInit {
  @Input() screenshotData: any;

  emailFrom: any[] = [
    { viewValue: 'Current User', value: 'currentUser' },
    { viewValue: 'Current Practice', value: 'currentPractice' },
    { viewValue: 'Meeting Demo', value: 'meetingDemo' }
  ];

  patientID: string;
  patient: PatientDataModel = null;
  patientEmail: string = '';

  subject: string = '';
  body: string = '';
  location: string = '';

  tdoUniversitySelected: boolean = false;
  tdoUniversityOptions: string[] = [
    'Bone Grafting', 'Calcified Cases', 'Cases', 'CBCT', 'Complex Anatomy',
    'Dentin Conversation', 'Ergonomics', 'General'
  ];

  constructor(public globals: Globals, public patientService: PatientService,
              public fileService: FileManagerService, public email: TreatmentPlanningService,
              public snackBar: MatSnackBar, public locationService: LoginService) { }

  ngOnInit() {
    this.patientID = this.globals.currentPatientId;
    this.locationService.getLocations().subscribe(res => {
      for (let i = 0; i < res.length; i++) {
        if (res[i].locid === this.globals.LOCID) {
          this.location = res[i].LocationName;
        }
      }
    });
    this.patientService.getPatient(this.patientID).subscribe(res =>
      this.patient = res
    );
    console.log(this.patient);
  }

  send() {
    const emailObj = {
      email: this.patientEmail,
      practice: this.location,
      subject: this.subject,
      body: this.body,
      imageData: this.screenshotData
    };
    console.log(JSON.stringify(emailObj));
    try {
      this.fileService.sendCollageEmail(emailObj).subscribe(res => {
        this.snackBar.open('Sent', 'Success', {
          duration: 3000,
          verticalPosition: 'top'
        });
        console.log(res.subject);
      });

    }
    catch (e) {
      this.snackBar.open(e, 'Error', {
        duration: 3000,
        verticalPosition: 'top'
      });
      console.log(e);
    }
  }
}
